import { render } from "./CatalogFooter.vue?vue&type=template&id=0463c3b8&scoped=true"
import script from "./CatalogFooter.vue?vue&type=script&lang=js"
export * from "./CatalogFooter.vue?vue&type=script&lang=js"

import "./CatalogFooter.vue?vue&type=style&index=0&id=0463c3b8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0463c3b8"]])

export default __exports__